module.exports = __webpack_public_path__ + "static/greenCurtain-ba35a891a44acf9da64e1a8a7de268e3.jpg";